import { Router, RouterLink } from '@angular/router';
import { Component, inject, signal } from '@angular/core';

import { AssetFormatterPipe } from '@pipes/asset-formatter-pipe';
import { FormComponent } from '@classes/form';
import { MagazineDetailData } from '@models/magazine-detail';
import { SpinnerComponent } from '@components/spinner/spinner.component';
import { Content } from '@components/content/content';

@Component({
  imports: [RouterLink, SpinnerComponent, AssetFormatterPipe, Content],
  selector: 'app-magazine-detail',
  styleUrl: './magazine-detail.scss',
  templateUrl: './magazine-detail.html',
})
export class MagazineDetail extends FormComponent {
  private router = inject(Router);

  override data = signal<MagazineDetailData>(new MagazineDetailData());

  ngOnInit(): void {
    this.route.paramMap.subscribe((params) => {
      const slug = params.get('slug') ?? '';

      this.restart();

      if (slug) {
        this.loadEndpoint = `api/magazine/${slug}`;

        this.load();
      } else {
        this.router.navigate(['/404'], { replaceUrl: true });
      }
    });
  }

  restart() {
    this.initialized.set(false);
    this.startLoading();
    this.data.set(new MagazineDetailData());
  }

  override onLoadSuccess(response: any): void {
    this.data.set(response.data);

    super.onLoadSuccess(response);
  }

  override onLoadError(error: any): void {
    this.router.navigate(['/404'], { replaceUrl: true });

    console.error(error);
  }
}
